import React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import ClientAutocomplete from "@/components/ClientAutocomplete";
import PhoneInputIntl from "@/components/PhoneInputIntl";

/**
 * Step 3 (partner / sales only): client details that get associated with
 * the simulation and pushed to the FDP ERP system. ClientAutocomplete
 * pulls past clients from /api/partner/clients so the user can pick an
 * existing record instead of retyping email/phone.
 */
export default function ClientInfoStep({ client, onChange, onPick }) {
  const { t } = useTranslation();

  return (
    <div
      className="border border-white/10 rounded-lg bg-zinc-900/30 p-6 md:p-8 mt-6"
      data-testid="client-info-section"
    >
      <div className="flex items-center gap-3 mb-2">
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-orange-500/15 text-orange-400 text-sm font-bold">
          3
        </div>
        <h3 className="font-outfit font-bold text-white text-xl">
          {t("simulate.step_4_title")}
        </h3>
      </div>
      <p className="text-xs text-zinc-500 mb-6 ml-11">
        {t("simulate.step_4_hint")}
      </p>
      <div className="grid md:grid-cols-3 gap-3">
        <div>
          <Label className="text-xs uppercase tracking-[0.2em] text-zinc-400">
            {t("simulate.client_name")}
          </Label>
          <ClientAutocomplete
            value={client.name}
            onChange={(v) => onChange({ ...client, name: v })}
            onPick={onPick}
            field="name"
            placeholder={t("simulate.client_name_placeholder")}
            testid="client-name-input"
          />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-[0.2em] text-zinc-400">
            {t("common.phone")}
          </Label>
          <div className="mt-2">
            <PhoneInputIntl
              value={client.phone}
              onChange={(v) => onChange({ ...client, phone: v })}
              testid="client-phone-input"
            />
          </div>
        </div>
        <div>
          <Label className="text-xs uppercase tracking-[0.2em] text-zinc-400">
            {t("common.email")}
          </Label>
          <ClientAutocomplete
            value={client.email}
            onChange={(v) => onChange({ ...client, email: v })}
            onPick={onPick}
            field="email"
            placeholder={t("simulate.client_email_placeholder")}
            testid="client-email-input"
          />
        </div>
      </div>
    </div>
  );
}
